import BrickantaLogo from "@/assets/brickanta-logo-dark.svg";
import { Wrench } from "lucide-react";

export const MaintenanceScreen = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background px-6">
      <img src={BrickantaLogo} alt="Brickanta" className="h-12 sm:h-14 mb-10" />
      <div className="flex items-center gap-3 mb-4">
        <Wrench className="h-6 w-6 text-muted-foreground" />
        <h1 className="text-2xl font-semibold text-foreground">Maintenance</h1>
      </div>
      <p className="text-muted-foreground text-center max-w-md">
        We&apos;re performing maintenance and will be back shortly. Thank you for your
        patience.
      </p>
    </div>
  );
};
